import { CustomFormFieldCheckbox } from '@src/@data/types/customForms';
import { CustomInput, FormGroup } from 'reactstrap';

interface CustomFormCheckboxFieldProps {
  field: CustomFormFieldCheckbox;
  inputName: string;
  value?: boolean;
  onChangeField: (value: boolean) => void;
}

export const CustomFormCheckboxField: React.FC<CustomFormCheckboxFieldProps> =
  ({ field, inputName, value, onChangeField }) => {
    return (
      <FormGroup>
        <CustomInput
          id={inputName}
          label={field.name}
          type="checkbox"
          required={field.mandatory}
          checked={value}
          onChange={(e) => onChangeField(e.target.checked)}
        />
      </FormGroup>
    );
  };
